<template>
  <header class="navigation inner">
    <div class="navigation-container ">
      <!-- Headedr left  Sec -->
      <div class="left-bar">
        <div class="upstox-logo">
          <a href="/" title="Upstox">
            <img src="https://upstox.com/app/themes/upstox/dist/img/logo/desktop-logo.svg" width="78" height="42"
              alt="Upstox Logo" class="Vector-Smart-Object">
          </a>
        </div>
        <div class="mobile-logo-panel-wrap">
          <div class="panel-logo" style="display:none">
            <a href="/" title="Upstox">
              <img width="90" height="42" alt="Upstox Logo"
                src="https://upstox.com/app/themes/upstox/dist/img/logo/mobile-logo.svg" class="inner-mobile">
              <img width="90" height="42" alt="Upstox Logo"
                src="https://upstox.com/app/themes/upstox/dist/img/logo/mobile-toggle.svg" class="toggle">
            </a>
          </div>
          <button class="nav-menu-button" id="nav-icon2" aria-label="Navbar menu">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <nav class="nav-links"> <!-- nav left links -->
          <div id="mega-menu-wrap-primary_navigation" class="mega-menu-wrap">
            <div class="mega-menu-toggle" tabindex="0">
              <div class='mega-toggle-block mega-menu-toggle-block mega-toggle-block-right mega-toggle-block-1'
                id='mega-toggle-block-1'></div>
            </div>
            <ul id="mega-menu-primary_navigation" class="mega-menu mega-menu-horizontal mega-no-js" data-event="hover"
              data-effect="disabled" data-effect-speed="200" data-second-click="close" data-document-click="collapse"
              data-vertical-behaviour="standard" data-breakpoint="1279" data-unbind="true">
              <li
                class='mega-oda-mobile mega-mobile-event mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-align-bottom-left mega-menu-flyout mega-hide-on-desktop mega-menu-item-19280 oda-mobile mobile-event'
                id='mega-menu-item-19280'><a class="mega-menu-link" href="https://wa.me/+917092362098"
                  tabindex="0">Open Demat Account</a></li>
              <li
                class='mega-oda-mobile mega-custom-login-param mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-align-bottom-left mega-menu-flyout mega-hide-on-desktop mega-menu-item-19296 oda-mobile custom-login-param'
                id='mega-menu-item-19296'><a class="mega-menu-link" href="#login" tabindex="0">Sign
                  In</a></li>
              <li
                class='mega-mega-menu-hover-dropdown mega-nav-bar_Company mega-nav-bar_Product_and_Tools mega-invest-custom mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-has-children mega-align-bottom-left mega-menu-megamenu mega-hide-on-mobile mega-menu-item-28609 mega-menu-hover-dropdown nav-bar_Company nav-bar_Product_and_Tools invest-custom invest-event'
                id='mega-menu-item-28609'><a class="mega-menu-link" href="/invest-in-share-market/"
                  aria-haspopup="true" tabindex="0">Invest</a>
                <ul class="mega-sub-menu">
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-55'
                    id='mega-menu-item-nav_menu-55'>
                    <p class="mega-block-title">Invest</p>
                    <div class="menu-header-products-subnav-2-container">
                      <ul id="menu-header-products-subnav-2" class="menu">
                        <li id="menu-item-19304"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-19304"><a
                            href="/invest-in-share-market/">Stocks</a></li>
                        <li id="menu-item-10009"
                          class="nav-bar_Money_Plant menu-item menu-item-type-custom menu-item-object-custom menu-item-10009">
                          <a href="/mutual-funds/">Mutual Funds</a></li>
                        <li id="menu-item-12718"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12718"><a
                            href="/ipo/">IPOs</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-56'
                    id='mega-menu-item-nav_menu-56'>
                    <p class="mega-block-title">Tools</p>
                    <div class="menu-invest-tools-container">
                      <ul id="menu-invest-tools" class="menu">
                        <li id="menu-item-49133"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49133"><a
                            href="/income-tax-calculator/">Income Tax Calculator</a></li>
                        <li id="menu-item-28624"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-28624"><a
                            href="/calculator/mutual-fund-return/">MF Return Calculator</a></li>
                        <li id="menu-item-49219"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49219"><a
                            href="/calculator/sip-calculator/">SIP Calculator</a></li>
                        <li id="menu-item-28626"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-28626"><a
                            href="/calculator/elss/">ELSS Calculator</a></li>
                        <li id="menu-item-49136"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49136"><a
                            href="/gold-rates/">Gold Rate Tracker</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-74'
                    id='mega-menu-item-nav_menu-74'>
                    <p class="mega-block-title">Holidays</p>
                    <div class="menu-holidays-container">
                      <ul id="menu-holidays" class="menu">
                        <li id="menu-item-48144"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-48144"><a
                            href="/stocks-market/share-market-holidays/">Trading Holidays 2025</a></li>
                        <li id="menu-item-48145"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-48145"><a
                            href="/stocks-market/nse-holidays/">NSE Holidays 2025</a></li>
                        <li id="menu-item-48146"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-48146"><a
                            href="/stocks-market/bse-holidays/">BSE Holidays 2025</a></li>
                        <li id="menu-item-48147"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-48147"><a
                            href="/stocks-market/mcx-holidays/">MCX Holidays 2025</a></li>
                        <li id="menu-item-49874"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49874"><a
                            href="/stocks-market/nse-bse-share-market-timing-in-india/">Stock Market
                            Timings</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-76'
                    id='mega-menu-item-nav_menu-76'>
                    <p class="mega-block-title">More</p>
                    <div class="menu-ipo-container">
                      <ul id="menu-ipo" class="menu">
                        <li id="menu-item-49348"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49348"><a
                            href="/amc/">Mutual Fund AMCs</a></li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li
                class='mega-mega-menu-hover-dropdown mega-trade-custom mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-has-children mega-align-bottom-left mega-menu-megamenu mega-hide-on-mobile mega-menu-item-28608 mega-menu-hover-dropdown trade-custom invest-event'
                id='mega-menu-item-28608'><a class="mega-menu-link"
                  href="/trade-in-futures-and-options/" aria-haspopup="true" tabindex="0">Trade</a>
                <ul class="mega-sub-menu">
                  <li
                    class='hidden mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-77'
                    id='mega-menu-item-nav_menu-77'>
                    <div class="menu-header-trade-banner-subnav-container">
                      <ul id="menu-header-trade-banner-subnav" class="menu">
                        <li id="menu-item-49419"
                          class="uplearn-submenu-img trade-banner-mega menu-item menu-item-type-custom menu-item-object-custom menu-item-49419">
                          <a href="/tick-by-tick-trading/"><img
                              src="https://assets.upstox.com/website/images/tbt-nav-banner.webp" alt="Uplearn"
                              loading="lazy" /></a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-57'
                    id='mega-menu-item-nav_menu-57'>
                    <p class="mega-block-title">Trade</p>
                    <div class="menu-trade-trade-container">
                      <ul id="menu-trade-trade" class="menu">
                        <li id="menu-item-28635"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-28635"><a
                            href="/trade-in-futures-and-options/">Futures &#038; Options</a></li>
                        <li id="menu-item-28636"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-28636"><a
                            href="/trade-in-futures-and-options/">Commodities</a></li>
                        <li id="menu-item-28637"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-28637"><a
                            href="/trade-in-futures-and-options/">Currency</a></li>
                        <li id="menu-item-38437"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-38437"><a
                            href="/free-chart-view-for-live-trading/">Upstox x TradingView</a></li>
                        <li id="menu-item-49569"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49569"><a
                            href="/trade-on-charts/">Chart 360</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-58'
                    id='mega-menu-item-nav_menu-58'>
                    <p class="mega-block-title">Tools</p>
                    <div class="menu-header-tools-calculators-container">
                      <ul id="menu-header-tools-calculators" class="menu">
                        <li id="menu-item-10037"
                          class="nav-bar_Brokerage_Calculator menu-item menu-item-type-post_type menu-item-object-page menu-item-10037">
                          <a href="/calculator/brokerage-calculator/">Brokerage Calculator</a></li>
                        <!-- <li id="menu-item-10038"
                          class="nav-bar_Span_Calculator menu-item menu-item-type-post_type menu-item-object-page menu-item-10038">
                          <a href="/calculator/span-calculator/">Span Calculator</a></li> -->
                        <li id="menu-item-25667"
                          class="nav-bar_Span_Calculator menu-item menu-item-type-post_type menu-item-object-page menu-item-25667">
                          <a title="NPV Calculator" href="/calculator/npv/">NPV Calculator</a></li>
                        <li id="menu-item-49264"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49264"><a
                            href="/calculator/lumpsum-calculator/">Lumpsum Calculator</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-59'
                    id='mega-menu-item-nav_menu-59'>
                    <p class="mega-block-title"> Tools</p>
                    <div class="menu-header-tools-calculators-3-container">
                      <ul id="menu-header-tools-calculators-3" class="menu">
                        <li id="menu-item-26411"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-26411"><a
                            href="/calculator/nps/">NPS Calculator</a></li>
                        <li id="menu-item-26152"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-26152"><a
                            href="/calculator/option-value/">Option Value Calculator</a></li>
                        <li id="menu-item-26153"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-26153"><a
                            href="/calculator/swp/">SWP Calculator</a></li>
                        <li id="menu-item-28645"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-28645"><a
                            href="/calculator/future-value/">Future Value Calculator</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-1-of-5 mega-menu-item-nav_menu-60'
                    id='mega-menu-item-nav_menu-60'>
                    <p class="mega-block-title"> Tools</p>
                    <div class="menu-header-tools-calculators-2-container">
                      <ul id="menu-header-tools-calculators-2" class="menu">
                        <li id="menu-item-28648"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-28648"><a
                            href="/calculator/">View all calculators</a></li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li
                class='mega-mega-has-icon mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-has-children mega-align-bottom-left mega-menu-flyout mega-has-icon mega-hide-on-desktop mega-menu-item-28662 mega-has-icon invest-event'
                id='mega-menu-item-28662'><a class="dashicons-plus mega-menu-link"
                  href="/invest-in-share-market/" aria-haspopup="true" tabindex="0">Invest</a>
                <ul class="mega-sub-menu">
                  <li
                    class='mega-mobile-prod-title mega-mobile-cal-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28667 mobile-prod-title mobile-cal-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-28667'><a class="mega-menu-link"
                      href="/invest-in-share-market/">Invest</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28668 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-28668'><a class="mega-menu-link"
                      href="/invest-in-share-market/">Stocks</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28669 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-28669'><a class="mega-menu-link" href="/mutual-funds/">Mutual
                      Funds</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28670 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-28670'><a class="mega-menu-link" href="/ipo/">IPOs</a></li>
                  <li
                    class='mega-mobile-cal-title mega-mobile-prod-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-35610 mobile-cal-title mobile-prod-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-35610'><a class="mega-menu-link" href="/calculator/">Tools and
                      calculators</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49104 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-49104'><a class="mega-menu-link"
                      href="/income-tax-calculator/">Income Tax Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-24044 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-24044'><a title="MF Returns Calculator" class="mega-menu-link"
                      href="/calculator/mutual-fund-return/">MF Returns Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49216 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-49216'><a class="mega-menu-link"
                      href="/calculator/sip-calculator/">SIP Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-26162 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-26162'><a title="ELSS Calculator" class="mega-menu-link"
                      href="/calculator/elss/">ELSS Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49139 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-49139'><a class="mega-menu-link" href="/gold-rates/">Gold Rate
                      Tracker</a></li>
                  <li
                    class='mega-mobile-cal-title mega-mobile-prod-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-42386 mobile-cal-title mobile-prod-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-42386'><a class="mega-menu-link"
                      href="/stocks-market/share-market-holidays-list-2024/">Holidays</a></li>
                  <li
                    class='mega-nav-bar_Brokerage_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-48153 nav-bar_Brokerage_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-48153'><a class="mega-menu-link"
                      href="/stocks-market/share-market-holidays/">Trading Holidays 2025</a></li>
                  <li
                    class='mega-nav-bar_Brokerage_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-48154 nav-bar_Brokerage_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-48154'><a class="mega-menu-link" href="/stocks-market/nse-holidays/">NSE Holidays
                      2025</a></li>
                  <li
                    class='mega-nav-bar_Brokerage_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-48155 nav-bar_Brokerage_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-48155'><a class="mega-menu-link" href="/stocks-market/bse-holidays/">BSE Holidays
                      2025</a></li>
                  <li
                    class='mega-nav-bar_Brokerage_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-48156 nav-bar_Brokerage_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-48156'><a class="mega-menu-link" href="/stocks-market/mcx-holidays/">MCX Holidays
                      2025</a></li>
                  <li
                    class='mega-nav-bar_Brokerage_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-42392 nav-bar_Brokerage_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-42392'><a class="mega-menu-link"
                      href="/stocks-market/nse-bse-share-market-timing-in-india/">Share Market
                      Timing</a></li>
                  <li
                    class='mega-mobile-cal-title mega-mobile-prod-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49355 mobile-cal-title mobile-prod-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-49355'><a class="mega-menu-link" href="#">More</a></li>
                  <li
                    class='mega-nav-bar_Brokerage_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49357 nav-bar_Brokerage_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-49357'><a class="mega-menu-link" href="/amc/">Mutual Fund
                      AMCs</a></li>
                </ul>
              </li>
              <li
                class='mega-mega-has-icon mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-has-children mega-align-bottom-left mega-menu-flyout mega-has-icon mega-hide-on-desktop mega-menu-item-28661 mega-has-icon invest-event'
                id='mega-menu-item-28661'><a class="dashicons-plus mega-menu-link"
                  href="/trade-in-futures-and-options/" aria-haspopup="true" tabindex="0">Trade</a>
                <ul class="mega-sub-menu">
                  <li
                    class='mega-mobile-cal-title mega-mobile-prod-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49422 mobile-cal-title mobile-prod-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-49422'><a class="mega-menu-link"
                      href="/tick-by-tick-trading/">Tick-By-Tick</a></li>
                  <li
                    class='mega-mobile-cal-title mega-mobile-prod-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28675 mobile-cal-title mobile-prod-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-28675'><a class="mega-menu-link"
                      href="/trade-in-futures-and-options/">Trade</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28676 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28676'><a class="mega-menu-link"
                      href="/trade-in-futures-and-options/">Futures & Options</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28677 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28677'><a class="mega-menu-link"
                      href="/trade-in-futures-and-options/">Commodities</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28678 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28678'><a class="mega-menu-link"
                      href="/trade-in-futures-and-options/">Currency</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49566 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-49566'><a class="mega-menu-link" href="/trade-on-charts/">Chart
                      360</a></li>
                  <li
                    class='mega-mobile-cal-title mega-mobile-prod-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28689 mobile-cal-title mobile-prod-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-28689'><a class="mega-menu-link" href="/calculator/">Tools</a>
                  </li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-28680 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28680'><a class="mega-menu-link"
                      href="/calculator/brokerage-calculator/">Brokerage Calculator</a></li>
                  <!-- <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-28681 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28681'><a class="mega-menu-link"
                      href="/calculator/span-calculator/">Span Calculator</a></li> -->
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-28682 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28682'><a class="mega-menu-link" href="/calculator/npv/">NPV
                      Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-49267 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-49267'><a class="mega-menu-link"
                      href="/calculator/lumpsum-calculator/">Lumpsum Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-28684 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28684'><a class="mega-menu-link" href="/calculator/nps/">NPS
                      Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-28685 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28685'><a class="mega-menu-link"
                      href="/calculator/option-value/">Option Value Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-28686 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28686'><a class="mega-menu-link" href="/calculator/swp/">SWP
                      Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-28687 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28687'><a class="mega-menu-link"
                      href="/calculator/future-value/">Future Value Calculator</a></li>
                  <li
                    class='mega-nav-bar_Span_Calculator mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28688 nav-bar_Span_Calculator mobile-expanded-menu-item-color'
                    id='mega-menu-item-28688'><a class="mega-menu-link" href="/calculator/">View all
                      calculators</a></li>
                </ul>
              </li>
              <li
                class='mega-no-hover mega-invest-event mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-align-bottom-left mega-menu-flyout mega-menu-item-47297 no-hover invest-event'
                id='mega-menu-item-47297'><a class="mega-menu-link" href="/news/"
                  tabindex="0">News</a></li>
              <li
                class='mega-nav-bar_Company mega-mega-menu-hover-dropdown mega-uplearn-nav-submenu mega-custom-up mega-uplearn-custom mega-invest-event mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-has-children mega-align-bottom-left mega-menu-megamenu mega-hide-on-mobile mega-menu-item-24746 nav-bar_Company mega-menu-hover-dropdown uplearn-nav-submenu custom-up uplearn-custom invest-event'
                id='mega-menu-item-24746'><a class="mega-menu-link" href="/uplearn/"
                  aria-haspopup="true" tabindex="0">UpLearn</a>
                <ul class="mega-sub-menu">
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-3-of-9 mega-menu-item-nav_menu-50'
                    id='mega-menu-item-nav_menu-50'>
                    <p class="mega-block-title">Learning Center</p>
                    <div class="menu-header-learning-center-subnav-1-container">
                      <ul id="menu-header-learning-center-subnav-1" class="menu">
                        <li id="menu-item-24728"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24728"><a
                            href="/learning-center/demat-account/">Demat Account</a></li>
                        <li id="menu-item-24729"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24729"><a
                            href="/learning-center/trading-account/">Trading Account</a></li>
                        <li id="menu-item-24730"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24730"><a
                            href="/learning-center/online-trading/">Online Trading</a></li>
                        <li id="menu-item-24731"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24731"><a
                            href="/learning-center/intraday-trading/">Intraday Trading</a></li>
                        <li id="menu-item-49432"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49432"><a
                            href="/learning-center/futures-and-options/">Future and Options</a></li>
                        <li id="menu-item-49433"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49433"><a
                            href="/learning-center/mutual-funds/">Mutual Funds</a></li>
                        <li id="menu-item-49434"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49434"><a
                            href="/learning-center/share-market/">Share Market</a></li>
                        <li id="menu-item-49435"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-49435"><a
                            href="/learning-center/ipo/">IPO</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='hidden mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-2-of-9 mega-menu-item-nav_menu-52'
                    id='mega-menu-item-nav_menu-52'>
                    <p class="mega-block-title">Help Center</p>
                    <div class="menu-header-help-center-subnav-container">
                      <ul id="menu-header-help-center-subnav" class="menu">
                        <li id="menu-item-24741"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24741"><a
                            href="/support/solutions/162081/">Account Opening</a></li>
                        <li id="menu-item-24742"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24742"><a
                            href="/support/solutions/162101/">Post Trade actions</a></li>
                        <li id="menu-item-24743"
                          class="help-desk menu-item menu-item-type-custom menu-item-object-custom menu-item-24743"><a
                            href="/contact-us/raise-a-ticket/">Submit Helpdesk Ticket</a></li>
                        <li id="menu-item-38820"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-38820"><a
                            href="/announcements/">Announcements</a></li>
                      </ul>
                    </div>
                  </li>
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-2-of-9 mega-menu-item-nav_menu-53'
                    id='mega-menu-item-nav_menu-53'>
                    <p class="mega-block-title">Resources</p>
                    <div class="menu-header-resources-subnav-container">
                      <ul id="menu-header-resources-subnav" class="menu">
                        <li id="menu-item-24721"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24721"><a
                            href="/glossary/">Trading Glossary</a></li>
                        <li id="menu-item-24723"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-24723"><a
                            href="/market-talk/">Market Talk</a></li>
                        <li id="menu-item-37918"
                          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-37918"><a
                            href="/stocks-market/share-market-holidays/">Stock Market Holidays
                            Calendar 2025</a></li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li
                class='mega-uplearn-custom mega-mega-has-icon mega-invest-event mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-has-children mega-align-bottom-left mega-menu-flyout mega-has-icon mega-hide-on-desktop mega-menu-item-24747 uplearn-custom mega-has-icon invest-event'
                id='mega-menu-item-24747'><a class="dashicons-plus mega-menu-link" href="#" aria-haspopup="true"
                  tabindex="0">UpLearn</a>
                <ul class="mega-sub-menu">
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-39709 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-39709'><a class="mega-menu-link" href="/uplearn/">UpLearn</a>
                  </li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-43386 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-43386'><a class="mega-menu-link"
                      href="https://community.upstox.com/">Community</a></li>
                  <li
                    class='mega-mobile-prod-title mega-mobile-cal-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24753 mobile-prod-title mobile-cal-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-24753'><a class="mega-menu-link" href="#">Learning Center</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24754 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24754'><a class="mega-menu-link"
                      href="/learning-center/demat-account/">Demat Account</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24755 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24755'><a class="mega-menu-link"
                      href="/learning-center/trading-account/">Trading Account</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24756 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24756'><a class="mega-menu-link"
                      href="/learning-center/online-trading/">Online Trading</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24757 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24757'><a class="mega-menu-link"
                      href="/learning-center/intraday-trading/">Intraday Trading</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24758 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24758'><a class="mega-menu-link"
                      href="/learning-center/futures-and-options/">Future and Options</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24759 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24759'><a class="mega-menu-link"
                      href="/learning-center/mutual-funds/">Mutual Funds</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24760 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24760'><a class="mega-menu-link"
                      href="/learning-center/share-market/">Share Market</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24761 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24761'><a class="mega-menu-link"
                      href="/learning-center/ipo/">IPO</a></li>
                  <li
                    class='mega-mobile-prod-title mega-mobile-cal-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24762 mobile-prod-title mobile-cal-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-24762'><a class="mega-menu-link" href="#">Help Center</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24763 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24763'><a class="mega-menu-link"
                      href="/support/solutions/162081/">Account Opening</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24764 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24764'><a class="mega-menu-link"
                      href="/support/solutions/162101/">Post Trade actions</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24765 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24765'><a class="mega-menu-link"
                      href="/contact-us/raise-a-ticket/">Submit Helpdesk Ticket</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-38824 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-38824'><a class="mega-menu-link"
                      href="/announcements/">Announcements</a></li>
                  <li
                    class='mega-mobile-prod-title mega-mobile-cal-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24766 mobile-prod-title mobile-cal-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-24766'><a class="mega-menu-link" href="#">Resources</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24767 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24767'><a class="mega-menu-link" href="/glossary/">Trading
                      Glossary</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-24769 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-24769'><a class="mega-menu-link" href="/market-talk/">Market
                      Talk</a></li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-37912 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-37912'><a class="mega-menu-link"
                      href="/stocks-market/share-market-holidays/">Stock Market Holidays Calendar
                      2025</a></li>
                </ul>
              </li>
              <li
                class='mega-mega-menu-hover-dropdown mega-about-custom mega-mega-has-icon mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-has-children mega-align-bottom-left mega-menu-flyout mega-has-icon mega-hide-on-desktop mega-menu-item-28664 mega-menu-hover-dropdown about-custom mega-has-icon invest-event'
                id='mega-menu-item-28664'><a class="dashicons-plus mega-menu-link" href="/about/"
                  aria-haspopup="true" tabindex="0">About us</a>
                <ul class="mega-sub-menu">
                  <li
                    class='mega-mobile-cal-title mega-mobile-prod-title mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28691 mobile-cal-title mobile-prod-title mobile-expanded-menu-item-color'
                    id='mega-menu-item-28691'><a class="mega-menu-link" href="/about/">About us</a>
                  </li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28692 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-28692'><a class="mega-menu-link" href="/about/">Our story</a>
                  </li>
                  <li
                    class='mega-nav-bar_Pro_Web mega-mobile-expanded-menu-item-color mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-menu-item-28693 nav-bar_Pro_Web mobile-expanded-menu-item-color'
                    id='mega-menu-item-28693'><a class="mega-menu-link" href="/life-at-upstox/">Life
                      at Upstox</a></li>
                </ul>
              </li>
              <li
                class='mega-mega-menu-hover-dropdown mega-about-custom mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-item-has-children mega-align-bottom-left mega-menu-megamenu mega-hide-on-mobile mega-menu-item-28610 mega-menu-hover-dropdown about-custom invest-event'
                id='mega-menu-item-28610'><a class="mega-menu-link" href="/about/"
                  aria-haspopup="true" tabindex="0">About</a>
                <ul class="mega-sub-menu">
                  <li
                    class='mega-menu-item mega-menu-item-type-widget widget_nav_menu mega-menu-columns-2-of-6 mega-menu-item-nav_menu-61'
                    id='mega-menu-item-nav_menu-61'>
                    <p class="mega-block-title">About Us</p>
                    <div class="menu-about-us-container">
                      <ul id="menu-about-us" class="menu">
                        <li id="menu-item-28655"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-28655"><a
                            href="/about/">Our story</a></li>
                        <li id="menu-item-28656"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-28656"><a
                            href="/life-at-upstox/">Life at Upstox</a></li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li
                class='mega-no-hover mega-partner-with-nav mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-align-bottom-left mega-menu-flyout mega-menu-item-26618 no-hover partner-with-nav invest-event'
                id='mega-menu-item-26618'><a class="mega-menu-link" href="/become-sub-broker/"
                  tabindex="0">Partner with us</a></li>
              <li
                class='mega-no-hover mega-pricing-nav-link mega-invest-event mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-align-bottom-left mega-menu-flyout mega-menu-item-19283 no-hover pricing-nav-link invest-event'
                id='mega-menu-item-19283'><a class="mega-menu-link" href="/brokerage-charges/"
                  tabindex="0">Pricing</a></li>
              <li
                class='mega-no-hover mega-navbar-oda-btn mega-link-oda-cta-navbar mega-menu-item mega-menu-item-type-custom mega-menu-item-object-custom mega-align-bottom-left mega-menu-flyout mega-hide-on-desktop mega-hide-on-mobile mega-menu-item-19285 no-hover navbar-oda-btn link-oda-cta-navbar'
                id='mega-menu-item-19285'><a class="mega-menu-link" href="https://wa.me/+917092362098"
                  tabindex="0">Create Account</a></li>
            </ul>
          </div>
        </nav>
      </div> <!-- end of left bar div -->
      <!-- Headedr right  Sec -->
      <div class="right-bar">
        <a href="https://wa.me/+917092362098" class="mobile-sign-up">Sign up</a>
        <!-- search Box -->
        <div class="search-section hidden">
          <div class="search-container search-container-header">
            <div class="search-background ">
              <div class="segmented-search-container">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24"
                  class="search-icon nothover" style="height: 16px; width: 16px;">
                  <defs></defs>
                  <path stroke="currentColor" stroke-width="3"
                    d="M22 22l-7-7m2-5.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"></path>
                </svg>
                <img src="@/styles/img/searchsimple-hover.svg" alt="search-icon"
                  height="16" width="16" class="onhovr">
                <input type="text" id="segmented-scrip-search-input" autocomplete="off"
                  placeholder="Search any stock, MF (E.g: AXIS BANK)">
              </div>
            </div>
          </div>
          <div class="search-close">
            <span></span>
          </div>
        </div> <!-- end of search-section -->
        <button class="responsive-search-icon" aria-label="Scrip search icon"> <!-- search icon for responsive -->
          <span>
            <i class="fa fa-search"></i>
          </span>
        </button>
        <!-- end of search Box -->
        <nav class="nav-left-links"> <!-- nav right links -->
          <div class="menu-header-subnav-right-menu-container">
            <ul id="menu-header-subnav-right-menu" class="navmenu_right">
              <li id="menu-item-25408"
                class="create-acc-navbar-link menu-item menu-item-type-custom menu-item-object-custom menu-item-25408">
                <a href="https://wa.me/+917092362098">Open Demat Account</a></li>
              <li id="menu-item-25409"
                class="custom-login-param menu-item menu-item-type-custom menu-item-object-custom menu-item-25409"><a
                  href="#login">Sign In</a></li>
            </ul>
          </div>
        </nav>
      </div> <!-- end of right-bar div -->
      <!-- End Right bar -->
    </div> <!-- end of navigation-container  -->
  </header>
</template>

<script setup>
  import { onMounted } from "vue";
  onMounted(()=>{
    require("@/assets/js/navbar03.js")
    require("@/assets/js/maxmegamenu.js?ver=2.3.7.1")
  })
</script>
<style lang="scss" src="@/styles/3-modules/navbar-icon.scss"></style>
<style lang="scss" scoped>
  header.navigation {
    top: 50px !important;
  }

  body#hellobar-enable {
    margin-top: 108px !important;
  }

  .developer .developer_navigaion_wrap {
    position: fixed;
    top: 120px;
  }

  .developer .container {
    margin-top: 80px !important;
  }

  .hellobar {
    background-color: #EEEBE6;
    color: #5A298B;
    text-align: center;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2000;
    min-height: 32px;
    font-size: 14px;
    line-height: 16px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .hellobar-cta {
    border: 0px;
    width: 139px;
    height: 29px;
    background-color: white;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    color: #0046bb;
    display: inline-block;
    margin-left: 20px;
    cursor: pointer;
  }

  .hellobar-cta:active {
    opacity: 0.9;
  }

  .hellobar-arrow {
    margin-top: 2px;
    height: 14px;
    width: 14px;
    margin-left: 5px;
  }

  .hellobar {
    display: none;
  }

  body#hellobar-enable {
    margin-top: 0 !important;
  }

  header.navigation {
    top: 0px !important;
  }

  body#hellobar-enable {
    margin-top: 112px !important;
  }

  body#hellobar-enable .hellobar {
    display: flex;
    margin-bottom: 20px !important;
    align-items: center;
    position: static;
    background-color: #5A2989;
    column-gap: 0px;
  }

  #hellobar-enable .hellobar p {
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #fff;
  }

  @media screen and (max-width: 1279px) {
    .hellobar {
      font-size: 13px;
    }

    .home-container {
      margin-top: 35px !important;
    }

    .hellobar-cta {
      width: 95px;
      margin-left: 0px;
    }

    body#hellobar-enable div.mobile-logo-panel-wrap .panel-logo a {
      transform: none;
      top: 20px;
    }

    body#hellobar-enable {
      margin-top: 100px !important;
    }

    header.navigation div.navigation-container {
      height: 58px;
    }

    .hellobar-arrow {
      margin: 0px 16px 0px 0px;
    }


  }


  @media screen and (max-width: 640px) {

    body#hellobar-enable .hellobar {
      padding: 5px;
      column-gap: 5px !important;
    }

    #hellobar-enable .hellobar p {
      text-align: left;
      font-size: 12px;
    }

    .hellobar-arrow {
      height: 18px;
      width: 18px;
      margin: 0 5px 0 0;
    }


  }

  header.navigation {
    top: 0px !important;
  }
</style>